// extracted by mini-css-extract-plugin
export default {"blockedIcon":"styles_blockedIcon__S2VPr","twoFactorBadge":"styles_twoFactorBadge__9X8w5"};